import React from 'react';
import styled from 'styled-components';
import {
  Grid,
  Paper,
} from '@material-ui/core';

const Container = styled(Grid)`
  width: 100%;
  max-width: 1120px;
  height: 100vh;
  margin: 0 auto;
`;

const Wrapper = styled(Grid)`
  height: 100%;
`;

const LogoMark = styled.img`
  max-height: 60px;
  margin-bottom: 15px;
`;

const StyledPaper = styled(Paper)`
  max-width: 600px;
  margin: 20px;
  padding: 50px 30px;
  text-align: center;
`;

interface InformPageWrapperProps {
  children: React.ReactNode;
}

export const InformPageWrapper = ({ children }: InformPageWrapperProps) => (
  <Container>
    <Wrapper
      alignItems="center"
      container
      direction="column"
      justifyContent="center"
    >
      <StyledPaper variant="outlined">
        <LogoMark
          alt=""
          role="presentation"
          src="/muster_logomark_blue.png"
        />
        {children}
      </StyledPaper>
    </Wrapper>
  </Container>
);
